var Model = require('../Model');

var User = Object.create(Model)

User.name = 'User';
User['@class'] =  'User'
User.url = 'user'
User.fields = {
  firstName: {
    type: 'text',
    default: '',
    validators: {
      presence: true,
    }
  },
  lastName: {
    type: 'text',
    default: '',
    validators : {
      presence: true,
    }
  },
  username: {
    type: 'text',
    default: null
  },
  email: {
    type: 'text',
    default: null,
    validators: {
      presence: true,
      email: true
    }
  },
  sms: {
    type: 'text',
    default: null,
    validators:{
      format: {
        pattern: /^\+1\d{10}$/,
        message: "Phone number must be in E.164 format. Example: +13051234567"
      }
    }
  },
  useUsaUnits: {
    type: 'select',
    default: 0,
    options: [
      {name: 'On', value: 1},
      {name: 'Off', value: 0}
    ]
  },
  typewriterEffect: {
    type: 'select',
    default: 0,
    options: [
      {name: 'On', value: 1},
      {name: 'Off', value: 0}
    ]
  },
  homeLocation: {
    type: 'text',
    default: null
  },
  homeDashboard: {
    type: 'text',
    default: null
  },
  preferredTableView: {
    hidden: true,
    default: ''
  },
  commandNotificationsEnabled: {
    default: 1
  },
  commentNotificationsEnabled: {
    default: 1
  },
  inactive: {
    default: 0,
    validators: {
      presence: true
    },
    options: [
      {name: 'Yes', value: 1},
      {name: 'No', value: 0}
    ]
  },
  // managedByAzure: {
  //   type: 'select',
  //   default: false,
  //   validators: {
  //     presence: true
  //   },
  //   options: [
  //     {name: 'Yes', value: 1},
  //     {name: 'No', value: 0}
  //   ]
  // }
  isCalibrationSuperuser: {
    default: 0
  },

};

module.exports = User;
